import React, { useState, useContext, useEffect } from 'react';
import ModalNews from './ModalNews';

import MyNewsContext from '../context/NewsContext';

const News = ({ newN, number }) => {
    const { setNewN, setImage, files } = useContext(MyNewsContext);

    const [isModalNewsOpen, setIsModalNewsOpen] = useState(false);

    const newDate = new Date(newN.newCreationDate);
    const options = { month: 'short', day: 'numeric' };
    const newDateFormated = newDate.toLocaleDateString('es-ES', options);
    
    return (
        <>
            <ModalNews isModalNewsOpen={isModalNewsOpen} setIsModalNewsOpen={setIsModalNewsOpen} />
            <div className='xl:w-4/12 lg:px-4 lg:py-4 md:w-[50%] md:px-4 md:py-4 w-[80%] px-2 py-2 '>
                <button onClick={() => { setNewN(newN); setImage(`data:image/png;base64,${files[number]}`); setIsModalNewsOpen(true) }} className="bg-white hover:scale-105 shadow shadow-xl hover:shadow-xl hover:shadow-footer rounded-lg w-full duration-300 ">
                    <div className="newDiv lg:h-44 md:h-44 h-32 w-full rounded-t-lg" style={{ background: `url(data:image/png;base64,${files[number]}) center top/cover`}}>
                        <div className='bg-red-800 rounded-b-lg ml-3 py-2 px-1 text-white absolute'>
                            {newDateFormated.toUpperCase()}
                        </div>
                    </div>
                    <div className='py-2 px-3 text-left'>
                        <h3 className='font-semibold font-mono h-12'>
                            {newN.newTitle.slice(0, 65)}...
                        </h3>
                    </div>
                    <div className='px-3 pb-3 text-justify h-32 sm:h-20 break-words'>{newN.newDescription.slice(0, 80)}...</div>
                </button>
            </div>
        </>
    );
}


export default News;
